import React from 'react';

import type {
  CourseDefinitionQuizQuestionAnswerResponse,
  CourseSessionQuizQuestionAnswerResponse,
} from 'src/api/ProactApiClient';
import {CheckboxGroup} from 'src/design/atoms/CheckboxGroup';
import type {ISelectOption} from 'src/types/Form';

export interface SessionAnswerMultiChoiceProps {
  answers: CourseDefinitionQuizQuestionAnswerResponse[];
  sessionAnswers: CourseSessionQuizQuestionAnswerResponse[];
  onSessionAnswersChange: (
    answers: CourseSessionQuizQuestionAnswerResponse[]
  ) => void;

  disabled?: boolean;
  error?: boolean;
  showCorrectResult?: boolean;
}
export const SessionAnswerMultiChoice: React.FC<
  SessionAnswerMultiChoiceProps
> = ({answers, sessionAnswers, onSessionAnswersChange, disabled, error}) => {
  function getAnswerOptions(
    answer: CourseDefinitionQuizQuestionAnswerResponse
  ) {
    return {
      id: answer.id,
      label: answer.text,
    } as ISelectOption;
  }
  const options = answers.map(answer => getAnswerOptions(answer));

  const values = sessionAnswers
    .filter(i => i.isSelected === true)
    .map(i => String(i.answerDefinitionId));

  const handleChangeCallback = (values: string[]): void => {
    onSessionAnswersChange(
      sessionAnswers.map(answer => ({
        ...answer,
        isSelected: values.includes(String(answer.answerDefinitionId)),
      }))
    );
  };

  return (
    <CheckboxGroup
      label=""
      options={options}
      onChangeCallback={handleChangeCallback}
      values={values}
      disabled={disabled}
      error={error}
    />
  );
};
